import React from 'react';
import PropTypes from 'prop-types';

import styles from './PageWrapper.module.scss';

function PageWrapper({ title, children, hasWhiteWrapper }) {
  return (
    <div>
      {title ? (
        <h1 className="fs-32 fw-600 c-neutral-01 m-b-20">{title}</h1>
      ) : null}

      <div className={hasWhiteWrapper ? styles.inner_white : ''}>
        {children}
      </div>
    </div>
  );
}

PageWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  hasWhiteWrapper: PropTypes.bool,
};

PageWrapper.defaultProps = {
  title: null,
  hasWhiteWrapper: false,
};

export default PageWrapper;
